export const useBaseAlertController = defineStore("baseAlertController", () => {
  const isOpen = ref(false);

  const title = ref("");
  const message = ref("");
  const isMessageComponent = ref(false);
  const buttonLabel = ref("Ok");

  const open = (options?: {
    title?: string;
    message?: string;
    isMessageComponent?: boolean;
    buttonLabel?: string;
  }) => {
    isOpen.value = true;
    title.value = options?.title ?? "Alert";
    message.value = options?.message ?? "Are you sure you want to proceed?";
    isMessageComponent.value = options?.isMessageComponent ?? false;
    buttonLabel.value = options?.buttonLabel ?? "Ok";
  };

  const close = () => {
    isOpen.value = false;
  };

  return {
    isOpen,
    title,
    message,
    isMessageComponent,
    buttonLabel,
    open,
    close,
  };
});
